import { REGEX_PASSWORD } from "constants/common.constant";
import i18n from "i18n";
import * as yup from "yup";

export const schemaValidate = yup.object().shape({
  // oldPassword: yup
  //   .string()
  //   .trim()
  //   .required(i18n.t("login.password-required"))
  //   .matches(REGEX_PASSWORD, i18n.t("login.invalid-password")),
  newPassword: yup
    .string()
    .trim()
    .required(i18n.t("login.password-required"))
    .matches(REGEX_PASSWORD, i18n.t("login.invalid-password")),
  passwordConfirm: yup
    .string()
    .trim()
    .required(i18n.t("login.password-required")),
});
